import React, {useMemo} from 'react';


export default function ImageComponent(props) {
    return useMemo(() => (
        <img src={props.src} alt={props.alt} className={props.className}/>
    ), [props.src, props.alt, props.className]);
}
